// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import PipProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/pip-product-search-results';
import PipProductsDropDown from './pip-products-drop-down';
import {getFieldClassName} from '../../../shared/services/claim-shared-helper';
import {translate} from '../../../../shared/services/translation-service';

const LabeledPipProductsDropDown = ({className, errorMessage, highlightClass, isEditable, isValid, label, selectedValue, vsrMessage, ...props}) =>
    <LabeledFormInput
        className={getFieldClassName(className, isValid, highlightClass)}
        label={label}
    >
        <EditableField
            isEditable={isEditable}
            value={selectedValue}
        >
            <PipProductsDropDown
                {...props}
                className={className}
                value={selectedValue}
            />
        </EditableField>
        {isValid ?
            null :
            <span className='error-message'>
                <FormattedMessage id={errorMessage}/>
            </span>
        }
        {vsrMessage &&
            <span className='vsr-message'>{`${vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}</span>
        }
    </LabeledFormInput>;

LabeledPipProductsDropDown.displayName = 'LabeledPipProductsDropDown';
LabeledPipProductsDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(PipProductSearchResult)).isRequired,
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    vsrMessage: PropTypes.string
};

export default LabeledPipProductsDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-pip-products-dropdown.js